require("./bootstrap")
require("./sidebar-searchbar")
require("./active-navbar")
require("./checkPriceRange")
require("./slick-slider")
require("./product-page")
require("./upload-file")
require("./back-to-top")
require("./marquee")
